import { db } from '../services/firebase';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';

const searchId = "kpJQvSOGpEEIUsn2kYJI";

// List of collections to search
const collectionsToSearch = [
  'users',
  'products',
  'orders',
  'seatedCustomers',
  'waitingList',
  'wholesale',
  'wholesaleOrders',
  'inventory',
  'beans',
  'shops',
  'templates',
  'menuItems',
  'availableProducts',
  'deliveryLogs',
  'wasteData',
  'salesReports',
  'weeklySalesReports',
  'cashierData',
  'waiterData',
  'schedules',
  'legalDocuments',
  'notifications'
];

export const searchForDuplicateId = async () => {
  console.log(`🔍 Searching for ID: ${searchId}`);
  console.log('='.repeat(50));
  
  const results = [];
  let totalFound = 0;

  for (const collectionName of collectionsToSearch) {
    try {
      console.log(`📁 Searching collection: ${collectionName}`);
      
      // First try to get the document directly by ID
      const directDocRef = doc(db, collectionName, searchId);
      const directDocSnap = await getDoc(directDocRef);
      
      if (directDocSnap.exists()) {
        totalFound++;
        const data = directDocSnap.data();
        results.push({
          collection: collectionName,
          id: searchId,
          data: data,
          found: 'direct'
        });
        console.log(`✅ FOUND in ${collectionName} (direct lookup)`);
        console.log('Data:', data);
      }
      
      // Also search through all documents in case the ID appears in nested data
      const collectionRef = collection(db, collectionName);
      const snapshot = await getDocs(collectionRef);
      
      snapshot.forEach((docSnap) => {
        const data = docSnap.data();
        const docId = docSnap.id;
        
        // Check if this document contains the search ID anywhere in its data
        const dataString = JSON.stringify(data);
        if (dataString.includes(searchId) && docId !== searchId) {
          totalFound++;
          results.push({
            collection: collectionName,
            id: docId,
            data: data,
            found: 'nested',
            searchId: searchId
          });
          console.log(`🔗 FOUND reference in ${collectionName}/${docId}`);
          console.log('Data containing ID:', data);
        }
      });
      
    } catch (error) {
      console.log(`❌ Error searching ${collectionName}:`, error.message);
    }
  }
  
  console.log('='.repeat(50));
  console.log(`🎯 SEARCH COMPLETE`);
  console.log(`📊 Total occurrences found: ${totalFound}`);
  
  if (totalFound > 1) {
    console.log(`⚠️  DUPLICATES DETECTED! Found ${totalFound} occurrences`);
    console.log('📋 Summary of all occurrences:');
    results.forEach((result, index) => {
      console.log(`${index + 1}. Collection: ${result.collection}, Type: ${result.found}`);
    });
  } else if (totalFound === 1) {
    console.log(`✅ Single occurrence found (no duplicates)`);
  } else {
    console.log(`❌ ID not found in any collection`);
  }
  
  return {
    searchId,
    totalFound,
    results,
    hasDuplicates: totalFound > 1
  };
};

// Function to delete duplicates (use with caution!)
export const deleteDuplicates = async (keepCollection) => {
  console.log(`🗑️  Starting duplicate deletion process...`);
  console.log(`📌 Will keep the document in: ${keepCollection}`);
  
  const searchResults = await searchForDuplicateId();
  
  if (!searchResults.hasDuplicates) {
    console.log(`ℹ️  No duplicates to delete`);
    return;
  }
  
  const toDelete = searchResults.results.filter(
    result => result.collection !== keepCollection && result.found === 'direct'
  );
  
  console.log(`🎯 Planning to delete ${toDelete.length} duplicate documents`);
  
  // Uncomment the code below to actually perform deletions
  // WARNING: This will permanently delete data!
  /*
  for (const duplicate of toDelete) {
    try {
      await deleteDoc(doc(db, duplicate.collection, searchId));
      console.log(`✅ Deleted from ${duplicate.collection}`);
    } catch (error) {
      console.log(`❌ Failed to delete from ${duplicate.collection}:`, error.message);
    }
  }
  */
  
  console.log(`⚠️  Deletion is commented out for safety. Uncomment the code to actually delete.`);
  return toDelete;
};

// Export the search function to run immediately
export default searchForDuplicateId; 